import React from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FormikCheckbox } from '../../../../../components/prime-formik';
import useSubscriptionExpiredRestrictions from '../../../../../hooks/useSubscriptionExpiredRestrictions';

const messages = defineMessages({
  header: {
    id: 'file_import.header.active',
    defaultMessage: 'Activate Import File',
  },
  overwrite: {
    id: 'file_import.overwrite.checkbox',
    defaultMessage: 'Overwrite respondent information if it exists',
  },
});

const ActivateConfirmModal = ({ reject, confirm, modalOpen }) => {
  const { formatMessage } = useIntl();
  const header = formatMessage(messages.header);
  const overwriteText = formatMessage(messages.overwrite);
  const initialValues = {
    overwrite: false,
  };
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const dialogFooter = (
    <>
      <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
        {(text) => <Button type="button" className="p-button-secondary" label={text} onClick={reject} />}
      </FormattedMessage>
      &nbsp;
      <FormattedMessage id="actions.save" defaultMessage="Save">
        {(text) => <Button label={text} type="submit" disabled={subscriptionIsExpired} />}
      </FormattedMessage>
    </>
  );

  return (
    <Formik onSubmit={confirm} initialValues={initialValues}>
      {({ setFieldValue }) => {
        return (
          <Form>
            <Dialog header={header} footer={dialogFooter} visible={modalOpen} onHide={reject} modal>
              <div className="panel panel-no-border">
                <div className="panel-body">
                  <div className="p-grid p-fluid">
                    <div className="p-col">
                      <Field
                        id="overwrite"
                        name="overwrite"
                        component={FormikCheckbox}
                        labelText={overwriteText}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Dialog>
          </Form>
        );
      }}
    </Formik>
  );
};

ActivateConfirmModal.propTypes = {
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
};

export default ActivateConfirmModal;
